import { Redirect } from 'expo-router';
import { useAtomValue } from 'jotai';
import * as React from 'react';
import { BodySmallRegular, H6Emphasized, ScreenContainer } from 'smoothie';

import { captureWarning } from '../../../logger/Logger';
import { selectedFAQAtom } from '../../state/SettingsAtoms';

const FAQAnswerSettingsScreen = () => {
    const selectedFAQ = useAtomValue(selectedFAQAtom);

    if (selectedFAQ == null) {
        captureWarning('FAQAnswerSettingsScreen: selectedFAQ is null');
        return <Redirect href="/settings" />;
    }

    const { question, answer } = selectedFAQ;

    return (
        <ScreenContainer title="FAQs" hasBackButton={true}>
            <H6Emphasized marginBottom={20}>{question}</H6Emphasized>
            {typeof answer === 'string' ? (
                <BodySmallRegular>{selectedFAQ.answer}</BodySmallRegular>
            ) : (
                answer
            )}
        </ScreenContainer>
    );
};

export default FAQAnswerSettingsScreen;
